import { postRequest } from '@site/js/utils/request'

import { VideoPlayer } from './'

export class VideoDetailsComponent extends VideoPlayer {
  constructor(element: HTMLDivElement) {
    super(element.querySelector('.cmp-video-wrapper'), true)
    this.initVideoWrapper()
  }

  private updateViewCount(): void {
    const currentPagePath = window.location.origin
    const videoContainer = document.querySelector('.cmp-videodetails')
    if (!videoContainer) return
    const viewCounterUrl = videoContainer.getAttribute('data-view-counter-url')
    const videoName = videoContainer.getAttribute('data-video-name')

    const viewCountUrl = currentPagePath + viewCounterUrl

    this.videoPlayer.addEventListener(
      'play',
      () => {
        postRequest(viewCountUrl + '?videoName=' + videoName).catch(error => {
          console.error(error)
        })
      },
      { once: true },
    )
  }

  private initVideoWrapper({ withViewCount = true } = {}) {
    const captionsArr: HTMLTrackElement[] = this.element.dataset.captions ? JSON.parse(`[${this.element.dataset.captions}]`) : []
    captionsArr.forEach(element => {
      const track = document.createElement('track')
      track.kind = element.kind
      track.label = element.label
      track.srclang = element.srclang
      track.src = element.src
      this.videoPlayer.appendChild(track)
    })

    if (withViewCount) {
      this.updateViewCount()
    }
  }
}
